// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hd-0";
export var actionModalContentContainer = "_hd-1";
export var createTagButton = "_hd-2";
export var footerContainer = "_hd-7";
export var fullWidthDivider = "_hd-3";
export var hasCreateTagButton = "_hd-4";
export var noCreateTagButton = "_hd-5";
export var tagsContainer = "_hd-6";
export var tagsModalContentContainer = "_hd-8";